import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { PRODUCT_LINE_NAME_CODE } from '@ordersnproducts/modules/shared/constants/product-lines-codes';

@Injectable()
export class RepeatOrderFeature implements IFlagFeature {
  name = Features.RepeatOrder;

  protected multiItemEnabledCountries = {
    [COUNTRY_CODE.USA]: [PRODUCT_LINE_NAME_CODE.READYMIX],
  };

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    // All countries have multiItem support disabled except for those in multiItemEnabledCountries array
    if (this.isMultiItemEnabled(params)) {
      if (container[this.name].getValue().split(' ').includes(params.businessLineCode)) {
        return true;
      }

      if (params.businessLineCode === PRODUCT_LINE_NAME_CODE.ADMIXTURES) {
        return container[Features[`RepeatOrder_${params.businessLineCode}`]].isEnabled();
      }
    }

    return false;
  }

  protected isMultiItemEnabled(params: IFeatureParams) {
    const enabledBusinessLines = this.multiItemEnabledCountries[params.countryCode];
    if (enabledBusinessLines && enabledBusinessLines.length && enabledBusinessLines.includes(params.businessLineCode)) {
      return true;
    }

    return params.orderItemSize === 1;
  }
}
